<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.practitioners', 1) }}
                    </h3>
                </div>
            </div>

            <div class=" " :class="[ mobileView ? 'pt-3': 'card-body']">
                <b-form  @reset="onReset" v-if="show">
                    <div class=" " :class="[ mobileView ? '': 'container']">

                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="nom-group"
                                        :label="$t('message.lastName')"
                                        label-for="nom"
                                        description=""

                                >

                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.nom.$model"
                                            :state="$v.form.nom.$dirty ? !(errorshasField('nom') || $v.form.nom.$error) : null"
                                            type="text"
                                            placeholder=""
                                            @focus="clearErrorField('nom')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback  v-if="!$v.form.nom.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('nom')">
                                        {{ getErrorsField('nom') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="prenom-group"
                                        :label="$t('message.firstName')"
                                        label-for="prenom"
                                >
                                    <b-form-input
                                            id="prenom"
                                            v-model="$v.form.prenom.$model"
                                            type="text"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="institution-group"
                                        :label="$tc('message.institutions',1)"
                                        label-for="institution"
                                >
                                    <select id="institution" v-model="$v.form.etablissement.$model"
                                            @change="clearErrorField('etablissement_id')"
                                            class="form-control is-invalid retirerBordure"
                                            multiple
                                    >
                                        <option data-placeholder="true"></option>
                                        <option value="0">
                                            {{ $t('message.addAll') | capitalize}}
                                        </option>
                                        <option v-for="item in mInstitutions" :key="item.value" :value="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>
                                    <div class="invalid-feedback" v-if="$v.form.etablissement.$error">
                                        {{ $t('message.requiredField') }}
                                    </div>
                                    <span v-if="errorshasField('etablissement_id')" style="color:red">
                                    {{getErrorsField('etablissement_id')}}
                                    </span>
                                </b-form-group>

                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="numero-group"
                                        :label="$t('message.orderNumber')"
                                        label-for="numero"
                                >
                                    <b-form-input
                                            id="numero"
                                            v-model="$v.form.numero.$model"
                                            :state="$v.form.numero.$dirty ? !(errorshasField('numero_ordre') || $v.form.numero.$error) : null"

                                            placeholder=""
                                            @focus="clearErrorField('numero_ordre')"
                                    ></b-form-input>

<!--                                    <b-form-invalid-feedback v-if="!$v.form.numero.required">-->
<!--                                        {{ $t('message.requiredField') }}-->
<!--                                    </b-form-invalid-feedback>-->

                                    <b-form-invalid-feedback v-if="!$v.form.numero.integer">
                                        {{ $t('message.integer', { n: 4 }) }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="!$v.form.numero.minLength">
                                        {{ $t('message.minCharacters', { n: 4 }) }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="errorshasField('numero_ordre')">
                                        {{ getErrorsField('numero_ordre') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="professions-group"
                                        :label="$t('message.select')+' '+$tc('message.professions', 1)"
                                        label-for="professions">
                                    <!-- Options -->
                                    <select id="professions"
                                            v-model="$v.form.profession.$model"
                                            class="form-control is-invalid retirerBordure"
                                            :state="$v.form.profession.$dirty ? !(errorshasField('profession_id') || $v.form.profession.$error) : null"
                                            required>
                                        <option v-for="item in mProfessions" :value="item.value" :key="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>

                                    <b-form-invalid-feedback v-if="$v.form.profession.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('profession_id')">
                                        {{ getErrorsField('profession_id') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="specialities-group"
                                        :label="$t('message.select')+' '+$tc('message.specialties', 1)"
                                        label-for="specialities">
                                    <!-- Options -->
                                    <select id="specialities"
                                            v-model="$v.form.specialite.$model"
                                            class="form-control is-invalid retirerBordure"
                                            :state="$v.form.specialite.$dirty ? !(errorshasField('specialite') || $v.form.specialite.$error) : null"
                                            required>
                                        <option v-for="item in pSpecialties" :value="item.value" :key="item.value"  @focus="clearErrorField('specialite_id')">
                                            {{ item.text }}
                                        </option>
                                    </select>

                                    <b-form-invalid-feedback v-if="$v.form.specialite.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('specialite_id')">
                                        {{ getErrorsField('specialite_id') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>
                            <b-col sm="3">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="indicatif-group"
                                        :label="$t('message.indicatif')"
                                        label-for="indicatif"
                                >
                                    <b-form-input
                                            id="indicatif"
                                            v-model="$v.form.indicatif.$model"
                                            :state="$v.form.indicatif.$dirty ? !($v.form.indicatif.$error) : null"
                                            required
                                            placeholder=""
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.indicatif.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.indicatif.numeric">
                                        {{ $t('message.integer', { n: 3 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.indicatif.maxLength">
                                        {{ $t('message.maxCharacters', { n: 3 }) }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="3">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="telephone-group"
                                        :label="$t('message.phoneNumber')"
                                        label-for="telephone"
                                >
                                    <b-form-input
                                            id="telephone"
                                            v-model="$v.form.telephone.$model"
                                            :state="$v.form.telephone.$dirty ? !(errorshasField('telephone') || $v.form.telephone.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('telephone')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.telephone.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
<!--                                    <b-form-invalid-feedback v-if="!$v.form.telephone.integer">-->
<!--                                        {{ $t('message.integer', { n: 9 }) }}-->
<!--                                    </b-form-invalid-feedback>-->
                                    <b-form-invalid-feedback v-if="!$v.form.telephone.numeric">
                                        {{ $t('message.integer', { n: 9 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.telephone.minLength">
                                        {{ $t('message.minCharacters', { n: 9 }) }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('telephone')">
                                        {{ getErrorsField('telephone') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="email-group"
                                        :label="$t('message.email')"
                                        label-for="email"
                                >
                                    <b-form-input
                                            id="email"
                                            v-model="$v.form.email.$model"
                                            :state="$v.form.email.$dirty ? !(errorshasField('email') || $v.form.email.$error) : null"
                                            type="email"
                                            placeholder=""
                                            @focus="clearErrorField('email')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.email.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.email.email">
                                        {{ $t('message.emailNotValid') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('email')">
                                        {{ getErrorsField('email') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="civility-group"
                                        :label="$t('message.civility')"
                                        label-for="specialities">
                                    <!-- Options -->
                                    <select id="civilite"  v-model="$v.form.civilite.$model"
                                            class="form-control is-invalid retirerBordure"
                                            :state="$v.form.civilite.$dirty ? !(errorshasField('civilite') || $v.form.civilite.$error) : null"
                                            required>
                                        <option v-for="item in civilites" :value="item.value" :key="item.value"  @focus="clearErrorField('civilite')">
                                            {{ item.text }}
                                        </option>
                                    </select>

                                    <b-form-invalid-feedback v-if="$v.form.civilite.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="errorshasField('civilite')">
                                        {{ getErrorsField('civilite') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="nationalite-group"
                                        :label="$t('message.nationality')"
                                        label-for="nationalite"
                                >
                                    <b-form-input
                                            id="nationalite"
                                            v-model="$v.form.nationalite.$model"
                                            :state="$v.form.nationalite.$dirty ? !(errorshasField('nationalite') || $v.form.nationalite.$error) : null"
                                            @focus="clearErrorField('nationalite')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('nationalite')">
                                        {{ getErrorsField('nationalite') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="single-group"
                                        :label="$t('message.select')+' '+$tc('message.countries', 1)"
                                        label-for="single">
                                    <!-- Options -->
                                    <select id="single"  v-model="$v.form.pays.$model "
                                            class="form-control is-invalid retirerBordure"
                                            :state="$v.form.pays.$dirty ? !(errorshasField('pays') || $v.form.pays.$error) : null"

                                            required>
                                        <option v-for="item in mCountries" :value="item.value" :key="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>

                                    <b-form-invalid-feedback v-if="errorshasField('pays')">
                                        {{ getErrorsField('pays') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.pays.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="ville-group"
                                        :label="$tc('message.cities', 1)"
                                        label-for="ville"
                                >
                                    <b-form-input
                                            id="ville"
                                            v-model="$v.form.ville.$model"
                                            :state="$v.form.ville.$dirty ? !(errorshasField('ville') || $v.form.ville.$error) : null"
                                            @focus="clearErrorField('ville')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('ville')">
                                        {{ getErrorsField('ville') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.ville.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="street-group"
                                        :label="$t('message.street')"
                                        label-for="street"
                                >
                                    <b-form-input
                                            id="street"
                                            v-model="$v.form.quartier.$model"
                                            :state="$v.form.quartier.$dirty ? !(errorshasField('quartier') || $v.form.quartier.$error) : null"
                                            @focus="clearErrorField('quartier')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('quartier')">
                                        {{ getErrorsField('quartier') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="zipCode-group"
                                        :label="$t('message.zipCode')"
                                        label-for="zipCode"
                                >
                                    <b-form-input
                                            id="zipCode"
                                            v-model="$v.form.code_postal.$model"
                                            :state="$v.form.code_postal.$dirty ? !(errorshasField('code_postal') || $v.form.code_postal.$error) : null"
                                            @focus="clearErrorField('code_postal')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('code_postal')">
                                        {{ getErrorsField('code_postal') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="address-group"
                                        :label="$t('message.address')"
                                        label-for="address"
                                >
                                    <b-form-input
                                            id="address"
                                            v-model="form.adresse"
                                            :state="$v.form.adresse.$dirty ? !(errorshasField('adresse') || $v.form.adresse.$error) : null"
                                            @focus="clearErrorField('adresse')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('adresse')">
                                        {{ getErrorsField('adresse') }}
                                    </b-form-invalid-feedback>

<!--                                    <b-form-invalid-feedback v-else-if="!$v.form.adresse.required">-->
<!--                                        {{ $t('message.requiredField') }}-->
<!--                                    </b-form-invalid-feedback>-->

                                </b-form-group>

                            </b-col>

                            <b-col sm="3" v-if="userIsMed">
                                <div>
                                    <label class="form__label" for="hasDesc">{{$t('message.isMedPatner')}}</label>
                                    <div class="toggle">
                                        <input id="hasDesc" type="checkbox" v-model="isMedicasure"/>
                                        <label for="hasDesc">
                                            <div class="toggle__switch"></div>
                                        </label>
                                    </div>
                                </div>
                            </b-col>

                            <b-col sm="3" v-if="userIsMed">
                                <div>
                                    <label class="form__label" for="hasDesc2">{{$t('message.userIsNotice')}}</label>
                                    <div class="toggle">
                                        <input id="hasDesc2" type="checkbox" v-model="isNotice"/>
                                        <label for="hasDesc2">
                                            <div class="toggle__switch"></div>
                                        </label>
                                    </div>
                                </div>
                            </b-col>


                            <b-col sm="6">
                                <b-form-group
                                        id="upload-group"
                                        :label="$t('message.uploadSignature')"
                                        label-for="upload"
                                >
                                    <b-form-file
                                            id="upload"
                                            :state="$v.form.signature.$dirty ? !$v.form.signature.$error : null"
                                            :placeholder="[mobileView ? $t('message.uploadFile_2'):$t('message.uploadFile_1')]"
                                            :file-name-formatter="formatNames"
                                            @change="setImage"
                                            class="d-flex"
                                    ></b-form-file>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

<!--                            <b-col sm="6">-->
<!--                                <b-container fluid class="p-4">-->
<!--                                    <b-row id="image">-->
<!--                                        <b-col>-->
<!--                                            <b-img-lazy-->
<!--                                                    class="img-preview"-->
<!--                                                    thumbnail-->
<!--                                                    :src="imageSrc(form.signature)"-->
<!--                                                    fluid-grow-->
<!--                                                    alt=""-->
<!--                                            ></b-img-lazy>-->
<!--                                        </b-col>-->
<!--                                    </b-row>-->
<!--                                </b-container>-->
<!--                            </b-col>-->

                        </b-row>
                    </div>
                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="can || hasAssistante">
                            <b-button  variant="primary" @click="onSubmit">
                                {{ $t('message.save') }}
                            </b-button>

<!--                            <b-button type="reset" variant="danger">-->
<!--                                {{ $t('message.reset') }}-->
<!--                            </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required, email, minLength,integer,numeric,maxLength} from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';

    export default {
        name: "AddPractitioner",
        filters: {
            capitalize: function (value) {
                if (!value) return '';
                value = value.toString().toUpperCase();
                return value;
            }
        },
        computed: {
            ...mapGetters(["institutions", "professions", "specialties", "countries", "errors",'hasAdminRole',
                'hasGestionnaireRole','hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

            userIsMed:function(){
                return (JSON.parse(localStorage.getItem('user')))['isMedicasure'];
            },

            mCountries: function() {
                let cArray = [];

                _.forOwn(this.countries, function(value, key) {
                    cArray.push({ text: value.name, value: value.name });
                });

                return cArray;
            },

            mInstitutions: function() {
                let iArray = [];

                _.forOwn(this.institutions, function(value, key) {
                    iArray.push({ text: value.name, value: value.id });
                });

                return iArray;
            },

            mProfessions: function() {
                let sArray = [];

                _.forOwn(this.professions, function(value, key) {
                    sArray.push({ text: value.name, value: value.id });
                });

                return sArray;
            },

            mSpecialties: function() {
                let sArray = [];

                _.forOwn(this.specialties, function(value, key) {
                    sArray.push({ text: value.name, value: value.id });
                });

                return sArray;
            }
        },

        data() {
            return {
                isMedicasure: false,
                isNotice:false,
                mobileView: true,
                form: {
                    nom: '',
                    prenom: '',
                    etablissement: [],
                    profession: "",
                    specialite: "",
                    telephone: '',
                    indicatif: '',
                    numero: '',
                    email: '',
                    civilite: '',
                    nationalite: '',
                    ville: '',
                    pays: '',
                    adresse: '',
                    quartier: '',
                    code_postal: '',
                    signature:''

                },
                pSpecialties: [],
                civilites: [
                    { value: 'Mme/Mlle.', text: 'Mme/Mlle.' },
                    { value: 'M.', text: 'M.' },
                    { value: 'Dr.', text: 'Dr.' },
                    { value: 'Pr.', text: 'Pr.' }
                ],

                show: true,


            }
        },

        watch: {
            $v: {
                handler: function (val) {
                    if(!val.$invalid) {
                        //
                    }
                }
            },

            'form.profession': function(newVal, oldVal) {
                let self = this;

                // Filter through specialties for specialties belonging to the selected profession
                let sArray = _.map(this.specialties, function(s) {
                    if (s.profession_id === newVal)
                        return s;
                });

                // Removed 'undefined' items from the array
                sArray = _.without(sArray, undefined);

                this.pSpecialties = [];

                //Add each specialty to the pSpecialties array
                _.forOwn(sArray, function(value, key) {
                    self.pSpecialties.push({ text: value.name, value: value.id });
                });
            }
        },

        methods: {
            formatNames(files) {
                return files[0].name
            },
            handleView() {
            this.mobileView = window.innerWidth < 991;
            },

            setImage(event) {
                this.form.signature = event.target.files[0];
            },

            imageSrc(img) {
                if (img) {
                    return URL.createObjectURL(img);
                }

                return '';
            },

            getCountries: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getCountries', { args, errorMessages });
            },

            getInstitutions: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getInstitutions', { args, errorMessages });
            },

            getProfessions: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getProfessions', { args, errorMessages });
            },

            getSpecialties: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getSpecialties', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();
                this.$v.$touch();
                if(!this.$v.$invalid) {

                    let formData = new FormData();

                    formData.append('nom', this.form.nom);
                    formData.append('prenom', this.form.prenom);
                    formData.append('etablissement_id', this.form.etablissement);
                    formData.append('profession_id', this.form.profession);
                    formData.append('specialite_id', this.form.specialite);
                    formData.append('email', this.form.email);
                    formData.append('telephone', this.form.indicatif+this.form.telephone,);
                    formData.append('numero_ordre', this.form.numero);
                    formData.append('civilite', this.form.civilite);
                    formData.append('nationalite', this.form.nationalite);
                    formData.append('ville', this.form.ville);
                    formData.append('adresse', this.form.adresse);
                    formData.append('pays', this.form.pays);
                    formData.append('quartier', this.form.quartier);
                    formData.append('code_postal', this.form.code_postal);
                    formData.append('signature', this.form.signature);
                    formData.append('isMedicasure', this.isMedicasure ? '1':'0');
                    formData.append('isNotice', this.isNotice ? '1':'0');

                    let successMessage = this.$i18n.t('message.practitionerCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createPractitioner', { args:formData, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.nom = '';
                this.form.prenom = '';
                this.form.etablissement = '';
                this.form.specialite = '';
                this.form.email = '';
                this.form.telephone = '';
                this.form.numero = '';
                this.form.civilite = '';
                this.form.nationalite = '';
                this.form.ville = '';
                this.form.pays = '';
                this.form.adresse = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                nom: {
                    required
                },
                prenom: {
                    //
                },
                etablissement: {
                    required
                },
                profession: {
                    required
                },
                specialite: {
                    required
                },
                telephone: {
                    required,
                    minLength: minLength(9),
                    numeric
                },
                indicatif: {
                    required,
                    maxLength: maxLength(3),
                    numeric
                },
                numero: {
                    // required,
                    // integer,
                    // minLength: minLength(4)
                },
                email: {
                    required,
                    email
                },
                civilite: {
                    required
                },
                nationalite: {
                    //
                },
                adresse: {
                    // required
                },
                ville: {
                    required
                },
                quartier: {
                    //
                },
                code_postal: {
                    //
                },
                pays: {
                    required
                },
                signature:{

                }
            }
        },
        created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
        },

        mounted() {
            // Retrieve list of countries
            this.getCountries();

            // Retrieve list of institutions
            this.getInstitutions();

            // Retrieve list of professions
            this.getProfessions();

            // Retrieve list of specialties
            this.getSpecialties();

           new SlimSelect({
                select: '#professions'
            });

 new SlimSelect({
                select: '#civilite'
            });

            new SlimSelect({
                select: '#specialities'
            });

            new SlimSelect({
                select: '#single',
                placeholder: 'Select your country'
            })

            new SlimSelect({
                select: '#institution',
                placeholder: 'Select institution',
            });

        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');

</style>